export type SignatureCard = {
  readonly title: string;
  readonly id: string;
  readonly color: string;
  readonly hasLogo: boolean;
};

export const MailSignatureLink =
  'https://outlook.office.com/mail/options/accounts-category/signatures-subcategory';

export const NewLogoURL =
  'https://file.fnf.co.kr/2025-08-29/KDTM2NtYJt2azyIYvacYFnf0H4DKvovvHyrN0Kfy.png';
